import RmsAdapter from './rms';

export default class FloorAdapter extends RmsAdapter {
  urlForFindAll(_, { adapterOptions }) {
    const url = super.urlForFindAll(...arguments);
    return `${url}?filter[location-id]=${adapterOptions.locationId}`;
  }
}
